import React, { useEffect, useState } from "react";
import DashboardPageTitle from "../../../component/DashboardPageTitle";
import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { fetchUserList } from "../../../api/ApiService";
import styles from "../../../layout/adminlayout/styles";
import { trimHash } from "../../../utils/common";
import DashboardLoader from "../../../component/DashboardLoader";
import theme from "../../../theme/Theme";
import { toast } from "react-toastify";
import { IoCopy } from "react-icons/io5";
import { Link } from "react-router-dom";
import NoDataFound from "../../../assets/svg/NoDataFound";

const AdminUsers = () => {
    const [isLoading, setIsLoading] =useState(true);
    const [usersList, setUsersList] = useState([]);
    useEffect(() => {
      const fetchData = async () => {
        setIsLoading(true);
        try {
          const response = await fetchUserList();
          if (response && response.data) {
            const data = response.data;
            setUsersList(data);
          }
        } catch (error) {
          console.error("Error fetching draws data:", error);
        } finally {
          setIsLoading(false);
        }
      };
  
      fetchData();
    }, []);

    const handleCopy = async (address) => {
        if (address) {
          try {
            await navigator.clipboard.writeText(address);
            toast.success("Address copied to clipboard!", {
              style: { fontSize: "14px" },
            });
          } catch (error) {
            console.error("Failed to copy address:", error);
            toast.error("Failed to copy address.", {
              style: { fontSize: "14px" },
            });
          }
        } else {
          toast.error("Address is not available.", {
            style: { fontSize: "14px" },
          });
        }
      };


    return( <Box>
        <DashboardPageTitle title={"Users List"} />
        <TableContainer  component={Paper} sx={styles.tableBackground}>
            <Table size="small">
                <TableHead>
                    <TableRow sx={{ backgroundColor: theme.custom.tableHeaderBg }}>
                        <TableCell sx={styles.ticketTitleStyle}>#</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>Name</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>Email</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>Tickets Purchased</TableCell>
                        <TableCell sx={styles.ticketTitleStyle}>Public Crypto Address</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {isLoading ? (
                        <TableRow>
                            <TableCell colSpan={6}>
                                <DashboardLoader isLoading={isLoading} />
                            </TableCell>
                        </TableRow>
                    ) : usersList.length > 0 ? (
                        usersList.map((user, index) => (
                            <TableRow key={index}
                            sx={{
                                backgroundColor:
                                  index % 2 !== 0 ? "#f3f3f3" : "transparent",
                              }}>
                            <TableCell>
                              <Typography sx={styles.ticketValueTitleStyle}>
                                {index + 1}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography sx={styles.ticketValueTitleStyle}>
                              <Link to={`/admin/users/${user.fullName}`} style={{ textDecoration: "none", color: theme.custom.link }}>
                      {user.fullName}
                    </Link>
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography sx={styles.ticketValueTitleStyle}>
                                {user.emailAddress}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography sx={styles.ticketValueTitleStyle}>
                                {user.totalTicketPurchase}
                              </Typography>
                            </TableCell>
                            <TableCell sx={styles.ticketValueTitleStyle}>
                                                {trimHash(user.publicAddress)}
                                                <IconButton
                      sx={styles.iconButtonStyle}
                      onClick={() => handleCopy(user.publicAddress)}
                    >
                      <IoCopy size={20} />
                    </IconButton>

                              
                            </TableCell>
                          </TableRow>
                        ))
                    ): (
                        <TableRow>
                        <TableCell colSpan={7} align="center">
                         <NoDataFound />

                          <Typography sx={{ color: "#525252", fontSize: "1rem", fontWeight: 500, textAlign: "center", padding: "2em 0"}}>
                          No User Found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )
                    }
                </TableBody>
                    
            </Table>
        </TableContainer>
    </Box>
)}

export default AdminUsers;